module.exports = __webpack_public_path__ + "img/IMG_8953.54a1a740.jpg";